@if (shouldRender) {
  @if (displayCollapsed) {
    <bingo-countdown-bar-collapsed [item]="getActiveItem()" (expand)="open()" />
  } @else {
    <div
      [class.is-urgent]="getActiveItem()?.urgent"
      [class.is-live]="getActiveItem()?.state === 'live'"
      [class.is-entering]="playIntroAnimation"
      [class.is-hiding]="playHideAnimation"
      [class.is-unhiding]="playUnhideAnimation"
      [class.is-removing-live]="playLiveRemovalAnimation"
      [class.is-live-empty-hiding]="playLiveEmptyHideAnimation"
      [class.is-next-entering]="playNextItemAnimation"
      class="countdown-bar countdown-bar--expanded"
      (animationend)="barAnimationEnd($event)"
    >
      @if (getActiveItem(); as item) {
        <div class="countdown-bar__top">
          <div class="countdown-bar__top-inner">
            <bingo-countdown-bar-header
              [item]="item"
              [collapsed]="false"
              [hiding]="playHideAnimation"
              [unhiding]="playUnhideAnimation"
              (hide)="hide($event)"
            />
          </div>
        </div>
      }

      <div
        [class.is-swipeable]="items.length > 1"
        class="countdown-bar__slides"
        (pointerdown)="onPointerDown($event)"
        (pointerup)="onPointerUp($event)"
        (wheel)="onWheel($event)"
      >
        @for (item of items; track item.id) {
          <bingo-countdown-bar-game
            [item]="item"
            [active]="$index === activeIndex"
            [transitioning]="isLiveTransitioning(item)"
            [entering]="playIntroAnimation"
            [nextEntering]="playNextItemAnimation"
            [removingLive]="playLiveRemovalAnimation"
            (openGame)="openGame(item)"
          />
        }
      </div>

      <bingo-countdown-bar-pagination
        [count]="items.length"
        [activeIndex]="activeIndex"
        (selectIndex)="goTo($event)"
      />
    </div>
  }
}
